import React, { useState } from 'react'
import ChangeOrderStatus from './ChangeOrderStatus'
import { dateFormat, formatCustomDate } from 'utils/dateFormat'
import { deliveryBox } from 'assets/icons'

const DeliveryStatus = ({ orderDetails, orderId, listing = () => { } }) => {
    const [changeStatusModal, setChangeStatusModal] = useState(false)

    const deliveredOn = Array.isArray(orderDetails?.orderStatusDetails)
        ? orderDetails.orderStatusDetails.find(item => item?.status === 'DELIVERED')?.date || ''
        : ''

    const statusMap = {
        PENDING: "Order Received",
        ACCEPTED: "Order Accepted",
        PROCESSING: "Order in Progress",
        OUT_FOR_DELIVERY: "Out for Delivery",
        DELIVERED: "Delivered",
        IS_READY_TO_PICK: "Ready to pickup"
    }

    return (
        <>
            {/* Case: Order Cancelled */}
            {orderDetails?.orderStatus === "CANCELLED" ? (
                <div className="mb-3 mt-5 col-7">
                    <button type="button" className="bg-danger text-white rounded-pill px-4 py-2 gap-2 mx-auto">
                        <img src={deliveryBox} alt="deliveryBox" />{' '}
                        Order Cancelled
                    </button>
                </div>
            ) : orderDetails?.orderStatus === "DELIVERED" ? (
                // Case: Order Delivered
                <div className="mb-3 mt-5 col-7">
                    <button type="button" className="bg-danger text-white rounded-pill px-4 py-2 gap-2 mx-auto">
                        <img src={deliveryBox} alt="deliveryBox" />{' '}
                        Order Delivered on {formatCustomDate(deliveredOn, 'MMMM DD, HH:mm A')}
                    </button>
                </div>
            ) : (
                // Default case: Order is in progress
                <>
                    <div className="row mt-5 mb-3">
                        <div className="mb-3 col-7">
                            <button type="button" className="btn-teal rounded-pill px-4 py-2 gap-2 mx-auto">
                                <img src={deliveryBox} alt="deliveryBox" />{' '}
                                Order Delivery on {dateFormat(orderDetails?.deliveryDate)} {orderDetails?.deliverySlot}
                            </button>
                        </div>
                        <div className="col-5">
                            <button
                                type="button"
                                className="button"
                                onClick={() => setChangeStatusModal(true)}
                            >
                                Change Status
                            </button>
                        </div>
                    </div>

                    {/* ------------------ Order Status Info ------------------ */}
                    <div className="container my-4">
                        <div className="d-flex justify-content-center flex-wrap gap-4">
                            {orderDetails?.orderStatusDetails && orderDetails?.orderStatusDetails.length > 0 &&
                                orderDetails?.orderStatusDetails.map((step, index) => (
                                    <div key={index} className="text-center">
                                        <div className="badge-pill-custom mb-2">{statusMap[step.status]}</div>
                                        <div className="fw-semibold">{formatCustomDate(step?.date, 'YYYY-MM-DD HH:mm A')}</div>
                                        {step.updatedBy && <div className="text-muted small">BY: nae{step.updatedBy?.name || step.updatedBy?.email}</div>}
                                    </div>
                                ))}
                        </div>
                    </div>
                </>
            )}

            <ChangeOrderStatus
                show={changeStatusModal}
                close={() => setChangeStatusModal(false)}
                data={orderDetails}
                listing={listing}
                orderId={orderId}
                orderDetails={orderDetails}
            />
        </>
    )
}

export default DeliveryStatus
